<template>
    <div class="accountSettings">
        <div class="set-left">
            <div class="set-title-top">
                <span>角色列表</span>
            </div>
            <el-scrollbar style="height:92%;width: 100%;">
                <div :class="['item',{'active':leftDataID == item.id}]" v-for="item in leftData" :key="item.id" @click="role_fn(item)">
                    <span>{{item.roleName}}</span>
                    <p>备注：{{item.remark}}</p>
                </div>
            </el-scrollbar>
        </div>
        <div class="set-right">
            <div class="top-title">
                <span>账户参数设置</span>
                  <el-button type="primary" @click="save_fn" class="last-el-button">保存设置</el-button>
            </div>
            <div class="right-item">
                <div class="item-top dominant">
                     限时设置
                </div>
                <div class="inp">
                    <span>刷卡后可使用的时长：</span>
                    <div class="tong">
                         <el-input v-model="timeNum" placeholder="请输入时长"></el-input>
                          <p>(分钟)</p>
                    </div>
                </div>
            </div>
            <div class="right-item">
                <div class="item-top dominant">
                     限时设置
                </div>
                <div class="inp">
                    <span>刷卡后可使用的用量：</span>
                    <div class="tong">
                         <el-input v-model="dosage" placeholder="请输入用量"></el-input>
                         <p>(m³)</p>
                    </div>
                </div>
            </div>
            <div class="right-item">
                <div class="item-top dominant" >
                     透支额度设置
                </div>
                <div class="inp">
                    <span style="margin-left: 28px;">账户可透支额度：</span>
                   <div class="tong">
                     <el-input v-model="overdraft" placeholder="请输入额度"></el-input>
                    <p>(元)</p>
                   </div>
                </div>
            </div>
          
        </div>
    </div>
</template>

<script>
import {findRoleFile,findByRoleFileId,saveLimitQuantity} from "../../api/zhongshanMeter";
export default {
    data() {
        return {
             timeNum: '',//限时时长
             dosage: '', //限制用量
             overdraft: '',//透支额度
             leftData:[],
             leftDataID:0,
        };
    },

    mounted() {
        this.getList() // 获取左边数据
        
    },
 

    methods: {
        //获取左边数据
        getList(){
            
          findRoleFile().then(res => {
             if(res.code == 200){
                this.leftData = res.data
                if(res.data.length != 0){
                   this.leftDataID = res.data[0].id
                   this.getRightList(this.leftDataID)
                }
               
             }
          })
        },
        //根据角色id获取右边数据
        getRightList(id){
            findByRoleFileId({'roleFileId':id}).then(res => {
                if(res.code == 200 && res.data != null){
                    this.timeNum = res.data.timeNum
                    this.dosage = res.data.dosage
                    this.overdraft = res.data.overdraft
                }else {
                     this.timeNum =  this.dosage = this.overdraft = ""
                }
            })
        },
        //点击左边
        role_fn(val){
            this.leftDataID = val.id
            this.getRightList(val.id)
        },
        //保存设置
        save_fn(){
            var d = {
                'roleFileId':this.leftDataID,
                'dosage':this.dosage,
                'overdraft':this.overdraft,
                'timeNum':this.timeNum,
            }
            saveLimitQuantity(d).then(res => {
                 if(res.code == 200){
                     this.getRightList(this.leftDataID)
                     this.$message({ showClose: true, message: '保存成功', type: 'success' });
                 }else {
                   res.message ? this.$message.error(res.message) : this.$message.error('保存失败');
                 
                 }
            })
        },
    },
};
</script>

<style lang="scss" scoped>
.accountSettings {
    width: 100%;
    height: 100%;
    display: flex;
    /deep/.el-scrollbar__wrap .el-scrollbar__view {
        width: 100%;
    }
}
  
   .set-right {
    flex-grow:1;
    background-color: #fff;
    padding: 20px;
       box-sizing: border-box;
       .top-title {
            border-bottom: 2px solid #e6e6e6;
            display: flex;
            justify-content: space-between;
            padding-bottom: 12px;
            span {
                font-size: 16px;
            }
       }
       .right-item {
        margin-top: 40px;
        height: 160px;
        border: 1px solid #e6e6e6;
        border-radius: 2px;
         .item-top {
            font-size: 16px;
            color: #fff;
            height: 44px;
            line-height: 44px;
            padding-left: 20px;
           }
           .inp {
             width: 500px;
             display: flex;
             align-items: center;
            //  justify-content: flex-end;
                margin-top: 40px;
                margin-left: 20px;
            .tong {
                display: flex;
               align-items: center;
            }
             /deep/.el-input {
                width: 240px;
                height: 36px;
             }
             /deep/.el-input__inner {
                height: 36px;
                line-height: 36px;
             }
            p {
                width: 40px;
                margin-left: 5px;

            }

           }
       }
       .save-btn {
        margin-top: 40px;
        display: flex;
        justify-content: flex-end;
       }
   }
</style>